import abi from './Transactions.json';

export const contractABI = abi.abi;
export const contactAddress = '0xA2A28c43f948BBAaC0FDB17ddAA32fA4051a04E8';